/**
 * @file 上传文件info
 * @author sunyingying01
 */

import {computed, makeObservable, observable} from 'mobx';
import getFileExtension from '@baidu/get-file-extension';

export class UploadFileInfo {
    /** uid */
    uid: string = '';
    /** 文件名 */
    name: string = '';
    /** 上传状态 none/成功/上传中 */
    status: 'none' | FileUploadStatusType = 'none';
    /** 上传进度 */
    percent: number = 0;
    /** 文件地址 后端返回 */
    fileUrl: string = '';
    /** 文件上传错误信息 */
    uploadErrorMessage?: string = '';

    /** 文件存储桶的名名字 */
    object_name?: string = '';
    /** 文件存储桶中的文件路径 */
    path?: string = '';

    /** 原始上传文件 */
    originalFile?: File;

    constructor() {
        makeObservable(this, {
            name: observable,
            status: observable,
            fileUrl: observable,
            percent: observable,
            uploadErrorMessage: observable,
            originalFile: observable,
            object_name: observable,
            path: observable,
            previewed: computed,
            fileExtension: computed
        });
    }

    /** 文件后缀 */
    get fileExtension(): string {
        if (!this.name) {
            return '';
        }
        return getFileExtension(this.name);
    }

    /** 是否python 文件 */
    get previewed(): boolean {
        return ['py'].includes(this.fileExtension);
    }
}
